module.exports = __webpack_public_path__ + "images/d42cd5f0ef23726aee9a5e6ca9dbb0e3.png";